import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bind from 'lodash-decorators/bind';
import OptimizeImagesService from 'services/OptimizeImages.service';

//styles
import styles from './GroupTile.module.scss';

export default class GroupTile extends Component {
  static propTypes = {
    enterprise: PropTypes.object,
    className: PropTypes.string
  };

  static defaultProps = {
    enterprise: {},
    className: ''
  };

  @Bind()
  handleClick() {
    this.props.onClick(this.props.enterprise);
  }

  render() {
    const { className, enterprise } = this.props;

    return (
      <div onClick={this.handleClick} className={`${styles.Tile} ${className}`}>
        <div className={styles.Overlay} />
        <img
          src={OptimizeImagesService.adjustImageSize(enterprise.logo)}
          alt="logo"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CSR/components/GroupTile/GroupTile.js